import { detectMarkers } from '../arucoRuntime'

// ArUco marker detection for the /vision play surface. Draws a box + id per
// detected marker and lists the ids in the insights panel.
export default function createMarkerDetector() {
    let canvas = null

    const frame = (video, vw, vh) => {
        const W = Math.min(640, vw)
        const H = Math.round((W * vh) / vw)
        if (!canvas) canvas = document.createElement('canvas')
        if (canvas.width !== W) canvas.width = W
        if (canvas.height !== H) canvas.height = H
        const ctx = canvas.getContext('2d', { willReadFrequently: true })
        ctx.drawImage(video, 0, 0, W, H)
        return { ctx, W, H }
    }

    return {
        id: 'marker',
        label: 'ArUco Markers',
        accent: '#eab308',

        async load() {},

        async detect({ video, vw, vh }) {
            if (!vw || !vh) return null
            const { ctx, W, H } = frame(video, vw, vh)
            const img = ctx.getImageData(0, 0, W, H)
            const markers = await detectMarkers(img)
            const boxes = markers.map((m) => {
                let minX = 1
                let minY = 1
                let maxX = 0
                let maxY = 0
                ;(m.corners || []).forEach((c) => {
                    const x = c.x / W
                    const y = c.y / H
                    if (x < minX) minX = x
                    if (y < minY) minY = y
                    if (x > maxX) maxX = x
                    if (y > maxY) maxY = y
                })
                return {
                    x: minX,
                    y: minY,
                    w: maxX - minX,
                    h: maxY - minY,
                    label: `#${m.id}`,
                    score: 1,
                }
            })
            return {
                boxes,
                insights: [
                    { label: 'Markers', value: markers.length },
                    {
                        label: 'IDs',
                        value: markers.length
                            ? markers.map((m) => m.id).join(', ')
                            : '—',
                    },
                ],
            }
        },

        reset() {},
        dispose() {
            canvas = null
        },
    }
}
